import { useTranslation } from 'react-i18next';
import { MIN_AGE, MAX_AGE, MIN_MAX_AGE_OPTIONS } from '@anytag/shared-constants';
import { RangeSliderInputField, RangeSliderInputFieldProps } from '@anytag/shared-molecules';
import { formatIntNumber } from '@anytag/shared-utils';
import { InfluencersFilterFormKeys } from '../schemaTypes';

type AgeFieldProps = Pick<RangeSliderInputFieldProps, 'hideSlider'>;
export const AgeField = ({ hideSlider }: AgeFieldProps) => {
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      title={t('General.Age')}
      options={MIN_MAX_AGE_OPTIONS}
      slideProps={{ step: 1, min: MIN_AGE, max: MAX_AGE }}
      minField={{ name: 'minAge', placeholder: `${formatIntNumber(MIN_AGE)}-` }}
      maxField={{ name: 'maxAge', placeholder: `${formatIntNumber(MAX_AGE)}+` }}
      hideSlider={hideSlider}
    />
  );
};
